import { ManifestComponentExtensionType } from '../ManifestStore';
import { getEditorPointerUniqueId } from '../getEditorPointerUniqueId';
import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
const GLOBAL_STATE_MAP = new Map();
export class ExternalStateHandler extends AbstractExternalAPIHandler {
  getState(editorPointer, type) {
    const idx = getEditorPointerUniqueId(editorPointer);
    const stateEntry = GLOBAL_STATE_MAP.get(idx);
    if (stateEntry) {
      return stateEntry.state;
    }
    return this.getViewState(editorPointer, type);
  }
  setState(editorPointer, type, state) {
    const idx = getEditorPointerUniqueId(editorPointer);
    const compRef = editorPointer.documentPointer;
    if (!state) {
      GLOBAL_STATE_MAP.delete(idx);
      this.dm.components.runtime.applyStates(compRef, null);
      return;
    }
    const viewStates = this.getViewStates(editorPointer, type);
    if (state in viewStates) {
      this.setViewState(editorPointer, type, state);
      return;
    }
    GLOBAL_STATE_MAP.set(idx, {
      state,
      editorPointer,
      type
    });
    this.dm.components.runtime.applyStates(compRef, state);
    return;
  }
  getViewStates(editorPointer, type) {
    if (type !== ManifestComponentExtensionType.OOI && type !== ManifestComponentExtensionType.BLOCKS) {
      return {};
    }
    const componentRef = editorPointer.documentPointer;
    const stageData = this.dm.platform.controllers.getStageData(componentRef);
    const viewStates = (stageData == null ? void 0 : stageData.viewStates) ?? {};
    if (Object.keys(viewStates).length === 0) {
      return {};
    }
    return Object.fromEntries(Object.entries(viewStates).map(_ref => {
      let [key, state] = _ref;
      return [key, {
        displayName: state.title
      }];
    }));
  }
  getViewState(editorPointer, type) {
    if (type !== ManifestComponentExtensionType.OOI && type !== ManifestComponentExtensionType.BLOCKS) {
      return null;
    }
    const componentRef = editorPointer.documentPointer;
    return this.hostAPI.viewState.getViewState(componentRef) || null;
  }
  setViewState(editorPointer, type, state) {
    if (type !== ManifestComponentExtensionType.OOI && type !== ManifestComponentExtensionType.BLOCKS) {
      return;
    }
    const componentRef = editorPointer.documentPointer;
    this.hostAPI.viewState.setViewState(componentRef, state);
  }
  getGlobalStates() {
    return Array.from(GLOBAL_STATE_MAP.values());
  }
}
//# sourceMappingURL=ExternalStateHandler.js.map